import * as PIXI from "pixi.js";
import { CurrencyInfo } from "../../../shared/models/currency-info";

export class PotTotalText {
  public container: PIXI.Container;
  private titleText: PIXI.Text;
  private titleTextStyle: PIXI.TextStyle = new PIXI.TextStyle({
    fontFamily: "Saira Semi Condensed",
    fontSize: 28,
    fill: "#999999",
    fontWeight: "500",
  });
  private amountText: PIXI.Text;
  private amountTextStyle: PIXI.TextStyle = new PIXI.TextStyle({
    fontFamily: "Saira Semi Condensed",
    fontSize: 28,
    fill: "#ffffff",
    fontWeight: "500",
  });
  private background: PIXI.Graphics;
  private backgroundColor = 0x0;
  private backgroundAlpha = 0.75;

  constructor(title: string, position: PIXI.Point) {
    this.container = new PIXI.Container();
    this.container.position.set(position.x + 40, position.y);

    this.background = new PIXI.Graphics();
    this.container.addChild(this.background);

    this.titleText = new PIXI.Text(title, this.titleTextStyle);
    this.container.addChild(this.titleText);

    this.amountText = new PIXI.Text("0", this.amountTextStyle);
    this.container.addChild(this.amountText);

    this.refreshBackgroud();
  }

  public setAmount(amount: string) {
    this.amountText.text = amount;
    this.refreshBackgroud();
  }

  private refreshBackgroud() {
    this.background.clear();
    const spacing = 0;
    const totalWidth = this.titleText.width + spacing + this.amountText.width;
    const height = Math.max(this.titleText.height, this.amountText.height);

    this.background.beginFill(this.backgroundColor, this.backgroundAlpha);
    this.background.drawRoundedRect(
      -totalWidth / 2 - 6,
      -height / 2 - 4,
      totalWidth + 12,
      height + 8,
      10,
    );
    this.background.endFill();

    this.titleText.x = -totalWidth / 2;
    this.titleText.y = -this.titleText.height / 2;
    this.amountText.x = this.titleText.x + this.titleText.width + spacing;
    this.amountText.y = -this.amountText.height / 2;
  }
}
